module.exports = __webpack_public_path__ + "static/media/deleteCross.011d7c85.svg";